// A FAQ belongs to exactly one page. The value is optional on the wire because
// every document written before sections existed is a homepage one.
export const FAQ_SECTIONS = ['homepage', 'ai-mentions'] as const;

export type FaqSection = typeof FAQ_SECTIONS[number];

export const DEFAULT_FAQ_SECTION: FaqSection = 'homepage';

export const FAQ_SECTION_LABELS: Record<FaqSection, string> = {
    'homepage': 'עמוד הבית',
    'ai-mentions': 'AI Mentions',
};

// Anything the server sends that this build does not know about reads as the
// homepage section - which is where a sectionless legacy document belongs.
export const toFaqSection = (value: string | undefined | null): FaqSection =>
    FAQ_SECTIONS.includes(value as FaqSection) ? value as FaqSection : DEFAULT_FAQ_SECTION;

export default interface FAQ {
    id: string;
    title: string;
    description: string;
    section?: string;
    createdAt: string;
    updatedAt?: string;
    order?: number;
}
